import { render, staticRenderFns } from "./NewPartnerSiteCustomStyleModal.vue?vue&type=template&id=a2edc10a&"
import script from "./NewPartnerSiteCustomStyleModal.vue?vue&type=script&lang=js&"
export * from "./NewPartnerSiteCustomStyleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports